import { object } from 'yup'
import { safify } from '../utils/safify'

export const designContent = object().meta({ hide: true }).transform(safify)
